import { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing, Potenciador } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
// Helper: ensure a <meta> tag with given attributes exists in <head>
const ensureMeta = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = Object.entries(attrs).filter(([k]) => k !== 'content').map(([k, v]) => `[${k}="${v}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attrs).forEach(([k, v]) => meta!.setAttribute(k, v));
};
// Helper: ensure a <link> tag exists in <head>
const ensureLink = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = `link[rel="${attrs.rel}"][href="${attrs.href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
};
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Keep the landing explicitly in Latin American Spanish and prevent auto-translation.
    document.documentElement.lang = 'es-419';
    document.documentElement.setAttribute('translate', 'no');
    document.documentElement.classList.add('notranslate');
    document.title = 'MEGAPACK BARBERO PRO — Tu barbería llena en 48 horas';
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'es-419'
    });
    ensureMeta({
      name: 'google',
      content: 'notranslate'
    });
    ensureMeta({
      name: 'language',
      content: 'Spanish'
    });
    ensureMeta({
      name: 'description',
      content: 'MEGAPACK BARBERO PRO: 6 niveles, 6 bonos, anuncios listos y guiones de WhatsApp para llenar tu barbería en 48 horas con publicidad.'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    // Performance: preconnect to Google Fonts (faster font load)
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    // Performance: preconnect to the CDN serving the hero mockup
    ensureLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    ensureLink({
      rel: 'preload',
      as: 'image',
      href: 'https://cdn.magicpatterns.com/uploads/sFEQjEmUsZK8vJ3cEmMSwK/mockup_principal_sticker.png',
      // @ts-ignore
      fetchpriority: 'high'
    });
  }, []);
  return <div lang="es-419" translate="no" className="min-h-screen bg-bg-base font-sans text-txt-body selection:bg-brandOrange selection:text-white notranslate" data-id="element-0" data-mp="1d4zucwek38t3">
      <MetaPixel data-id="element-1" data-mp="13eoeqclifb6d" />
      <SocialProofPopup data-id="element-2" data-mp="13e56jnlnw15j" />
      <Hero data-id="element-3" data-mp="13fg8rizgl0uj" />
      <SocialProof data-id="element-4" data-mp="13f7ylyuq09n1" />
      <Testimonials1 data-id="element-5" data-mp="13cbx60jnz2tu" />
      <Problem data-id="element-6" data-mp="1r4ipmom9qpnz" />
      <ProductTomos data-id="element-7" data-mp="1r3zgnxeljbm3" />
      <Bonuses data-id="element-8" data-mp="1r5kafkt36qiw" />
      <UrgencyCounter data-id="element-9" data-mp="1r52600w9t5zw" />
      <Pricing data-id="element-10" data-mp="1r2fx9xxn8kg3" />
      <Potenciador data-id="element-11" data-mp="1w33ookpsb3au" />
      <Testimonials2 data-id="element-12" data-mp="1w3lrk06ycfrq" />
      <Guarantee data-id="element-13" data-mp="1w2tyox4qow55" />
      <FAQ data-id="element-14" data-mp="1w19eo1g1wvlj" />
      <CostOfNotHaving data-id="element-15" data-mp="1w0zn49fcygdq" />
      <FinalCTA data-id="element-16" data-mp="1i4401d29uoeo" />
      <Footer data-id="element-17" data-mp="1i2j69pns79hv" />
    </div>;
}